import { styled } from '@mui/material';
import { BOTTOM_NAV_HEIGHT } from '../../constants';

const Root = styled('div')({
  // Root container styles
});

const TopContainer = styled('div')(({ theme }) => ({
  flexGrow: 1,
  maxHeight: `calc(100vh - (${BOTTOM_NAV_HEIGHT}px + ${theme.toolbarHeight}px))`,
}));

export { Root, TopContainer };
